// src/api/esupplyvet.js
import axios from "axios";
import setupInterceptors from "./interceptors";

const esupplyvetApi = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL_ESUPPLYVET,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json",
  },
});

setupInterceptors(esupplyvetApi);

export default esupplyvetApi;
